"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = dispatchPromise;
function dispatchPromise(type, dispatch, promise) {
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  dispatch({ type: type, status: "pending", params: params });
  return promise.then(function (result) {
    return (
      // $FlowFixMe no clue how to type promises properly
      dispatch({ type: type, status: "success", result: result, params: params })
    );
  }, function (error) {
    return (
      // $FlowFixMe no clue how to type promises properly
      dispatch({ type: type, status: "error", error: error, params: params })
    );
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvdXRpbC9kaXNwYXRjaC1wcm9taXNlLmpzIl0sIm5hbWVzIjpbImRpc3BhdGNoUHJvbWlzZSIsInR5cGUiLCJkaXNwYXRjaCIsInByb21pc2UiLCJwYXJhbXMiLCJzdGF0dXMiLCJ0aGVuIiwicmVzdWx0IiwiZXJyb3IiXSwibWFwcGluZ3MiOiI7Ozs7O2tCQUV3QkEsZTtBQUFULFNBQVNBLGVBQVQsQ0FDYkMsSUFEYSxFQUViQyxRQUZhLEVBR2JDLE9BSGEsRUFLRDtBQUFBLE1BRFpDLE1BQ1ksdUVBREUsRUFDRjs7QUFDWkYsV0FBUyxFQUFDRCxVQUFELEVBQU9JLFFBQVEsU0FBZixFQUEwQkQsY0FBMUIsRUFBVDtBQUNBLFNBQU9ELFFBQVFHLElBQVIsQ0FDTDtBQUFBO0FBQ0U7QUFDQUosZUFBUyxFQUFDRCxVQUFELEVBQU9JLFFBQVEsU0FBZixFQUEwQkUsY0FBMUIsRUFBa0NILGNBQWxDLEVBQVQ7QUFGRjtBQUFBLEdBREssRUFJTDtBQUFBO0FBQ0U7QUFDQUYsZUFBUyxFQUFDRCxVQUFELEVBQU9JLFFBQVEsT0FBZixFQUF3QkcsWUFBeEIsRUFBK0JKLGNBQS9CLEVBQVQ7QUFGRjtBQUFBLEdBSkssQ0FBUDtBQVFEIiwiZmlsZSI6ImRpc3BhdGNoLXByb21pc2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBkaXNwYXRjaFByb21pc2U8VD4oXG4gIHR5cGU6IHN0cmluZyxcbiAgZGlzcGF0Y2g6ICh7fSkgPT4gdm9pZCxcbiAgcHJvbWlzZTogUHJvbWlzZTxUPixcbiAgcGFyYW1zOiA/e30gPSB7fSxcbik6IFByb21pc2U8VD4ge1xuICBkaXNwYXRjaCh7dHlwZSwgc3RhdHVzOiBcInBlbmRpbmdcIiwgcGFyYW1zfSlcbiAgcmV0dXJuIHByb21pc2UudGhlbihcbiAgICByZXN1bHQgPT5cbiAgICAgIC8vICRGbG93Rml4TWUgbm8gY2x1ZSBob3cgdG8gdHlwZSBwcm9taXNlcyBwcm9wZXJseVxuICAgICAgZGlzcGF0Y2goe3R5cGUsIHN0YXR1czogXCJzdWNjZXNzXCIsIHJlc3VsdCwgcGFyYW1zfSksXG4gICAgZXJyb3IgPT5cbiAgICAgIC8vICRGbG93Rml4TWUgbm8gY2x1ZSBob3cgdG8gdHlwZSBwcm9taXNlcyBwcm9wZXJseVxuICAgICAgZGlzcGF0Y2goe3R5cGUsIHN0YXR1czogXCJlcnJvclwiLCBlcnJvciwgcGFyYW1zfSksXG4gIClcbn1cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/util/dispatch-promise.js
// module id = 584
// module chunks = 0